export default function Loading() {
  return (
    <div className="flex items-center justify-center w-full min-h-screen bg-stone-800">
      <div className="flex items-center justify-center w-full text-3xl h-full-header text-primary">
        loading...
      </div>
    </div>
  );
}
